var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Registrar Información" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:80",
                                    expression: "'required|max:80'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombre.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombre.id
                                  ),
                                  "data-vv-name": _vm.formFields.nombre.id,
                                  "data-testid":
                                    _vm.testId + "--cliente-proveedor-gps",
                                  disabled: _vm.readonly,
                                  counter: 80
                                },
                                model: {
                                  value: _vm.formFields.nombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombre.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.taller.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.taller.id
                                  ),
                                  "data-vv-name": _vm.formFields.taller.id,
                                  "data-testid": _vm.testId + "--taller",
                                  items: _vm.formFields.taller.items,
                                  disabled: _vm.readonly,
                                  "item-text": "nombre",
                                  "item-value": "id"
                                },
                                model: {
                                  value: _vm.formFields.taller.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.taller,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.taller.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:80",
                                    expression: "'required|max:80'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.responsable.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.responsable.id
                                  ),
                                  "data-vv-name": _vm.formFields.responsable.id,
                                  "data-testid":
                                    _vm.testId + "--cliente-proveedor-gps",
                                  disabled: _vm.readonly,
                                  counter: 80
                                },
                                model: {
                                  value: _vm.formFields.responsable.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.responsable,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.responsable.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("DatePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.fechaIngreso.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechaIngreso.id
                                  ),
                                  id: _vm.formFields.fechaIngreso.id,
                                  "test-id": _vm.testId + "--fecha-inicio",
                                  disabled: _vm.readonly
                                },
                                model: {
                                  value: _vm.formFields.fechaIngreso.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaIngreso,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaIngreso.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label: _vm.formFields.fechaSalida.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechaSalida.id
                                  ),
                                  id: _vm.formFields.fechaSalida.id,
                                  "test-id": _vm.testId + "--fecha-termino",
                                  disabled: _vm.readonly,
                                  min: _vm.fechaMinimaFin.format("YYYY-MM-DD")
                                },
                                model: {
                                  value: _vm.formFields.fechaSalida.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaSalida,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaSalida.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:80|numeric",
                                    expression: "'required|max:80|numeric'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.kilometraje.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.kilometraje.id
                                  ),
                                  "data-vv-name": _vm.formFields.kilometraje.id,
                                  "data-testid":
                                    _vm.testId + "--intervalo-transmiciones",
                                  disabled: _vm.readonly,
                                  counter: 80
                                },
                                model: {
                                  value: _vm.formFields.kilometraje.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.kilometraje,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.kilometraje.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:80|numeric",
                                    expression: "'max:80|numeric'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.horasMotor.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.horasMotor.id
                                  ),
                                  "data-vv-name": _vm.formFields.horasMotor.id,
                                  "data-testid":
                                    _vm.testId + "--cantidadActividadesBloque",
                                  disabled: _vm.readonly,
                                  counter: 80
                                },
                                model: {
                                  value: _vm.formFields.horasMotor.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.horasMotor,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.horasMotor.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label: _vm.formFields.fechaRealizacion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechaRealizacion.id
                                  ),
                                  id: _vm.formFields.fechaRealizacion.id,
                                  "test-id": _vm.testId + "--fecha-termino",
                                  disabled: _vm.readonly,
                                  min: _vm.fechaMinimaFin.format("YYYY-MM-DD")
                                },
                                model: {
                                  value: _vm.formFields.fechaRealizacion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaRealizacion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.fechaRealizacion.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("br"),
                      _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                        _c(
                          "div",
                          { attrs: { align: "left" } },
                          [
                            _c("v-flex", { attrs: { md12: "" } }, [
                              _c("h2", { staticClass: "h2_title" }, [
                                _vm._v("Seleccionar Actividades Realizadas")
                              ])
                            ])
                          ],
                          1
                        )
                      ]),
                      _c("v-divider"),
                      _c("CabeceraTabla", {
                        scopedSlots: _vm._u([
                          {
                            key: "izquierda",
                            fn: function() {
                              return [
                                _c("BuscadorOperacionCrud", {
                                  attrs: {
                                    filter:
                                      _vm.gridApi &&
                                      _vm.gridApi.setQuickFilter.bind(
                                        _vm.gridApi
                                      )
                                  }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _vm.readonly
                            ? _c("MantenedorGridVerDetalle", {
                                attrs: {
                                  "grid-options": _vm.gridOptions,
                                  "row-data": _vm.actividades
                                }
                              })
                            : _c("MantenedorGrid", {
                                attrs: {
                                  "grid-options": _vm.gridOptions,
                                  "row-data": _vm.actividades
                                }
                              })
                        ],
                        1
                      ),
                      _c("br"),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Actividades Extras" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md12: "" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label: _vm.formFields.actividadesExtras.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.actividadesExtras.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.actividadesExtras.id,
                                  disabled: _vm.readonly
                                },
                                model: {
                                  value: _vm.formFields.actividadesExtras.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.actividadesExtras,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.actividadesExtras.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:80|numeric",
                                    expression: "'max:80|numeric'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.horasHombre.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.horasHombre.id
                                  ),
                                  "data-vv-name": _vm.formFields.horasHombre.id,
                                  disabled: _vm.readonly,
                                  counter: 80
                                },
                                model: {
                                  value: _vm.formFields.horasHombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.horasHombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.horasHombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:80|numeric",
                                    expression: "'max:80|numeric'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.costoHorasHombre.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.costoHorasHombre.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.costoHorasHombre.id,
                                  "data-testid":
                                    _vm.testId + "--cantidadActividadesBloque",
                                  disabled: _vm.readonly,
                                  counter: 80
                                },
                                model: {
                                  value: _vm.formFields.costoHorasHombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.costoHorasHombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.costoHorasHombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:80|numeric",
                                    expression: "'max:80|numeric'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.costoInsumos.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.costoInsumos.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.costoInsumos.id,
                                  "data-testid":
                                    _vm.testId + "--cantidadActividadesBloque",
                                  disabled: _vm.readonly,
                                  counter: 80
                                },
                                model: {
                                  value: _vm.formFields.costoInsumos.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.costoInsumos,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.costoInsumos.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }